import {Component, OnInit, Input, ChangeDetectorRef,
  Output, EventEmitter, OnDestroy, ElementRef, ViewChild, AfterViewChecked, Renderer2 } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {forkJoin, Observable, of, Subscription, combineLatest } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { BroadcastService } from '../services/broadcast.service';

@Component({
    selector: 'app-virtual-autocomplete',
    templateUrl: './virtual-autocomplete.component.html',
    styleUrls: ['./virtual-autocomplete.component.scss'],
    standalone: false
})
export class VirtualAutocompleteComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() dataValues: Observable<any> = of([]);
  @Input() persistance: Observable<any> = of([]);
  @Input() placeholder;
  @Input() class;
  @Input() width;
  @Input() blocking: boolean;
  @Output() selectedValues = new EventEmitter();
  @ViewChild('ctrlInput') ctrlInput: ElementRef<HTMLElement>;
  autoCompleteWidth;
  isSearching: boolean;
  isComboxBoxOpen: boolean;
  accontListCtrl = new UntypedFormControl({value : '', disabled: true});
  filteredList = new Array<any>();
  allAccounts = new Array<any>();
  isAllSelected = false;
  noData = false;
  selectedAccounts = new Array<any>();
  subscriptions: Subscription[] = [];
  submittedNumber = 0;
  selectedAccountCopy = new Array<any>();
  autoCompleteTop = 0;
  dropDownHeight = 200;
  autoCompleteHeight = 258;
  constructor(
    private cdr: ChangeDetectorRef, private broadcastService: BroadcastService,
    private renderer: Renderer2, private elementRef: ElementRef) {
    const self = this;
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!self.elementRef.nativeElement.contains(e.target) && self.isSearching) {
        this.dismissSearchBox();
      }
    });
  }

  updateFilterList(list) {
    this.filteredList = list ? this._filter(list) : this.allAccounts.slice();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.dataValues.subscribe((data) => {
      this.allAccounts = data;
      if (this.allAccounts && this.allAccounts.length) { this.accontListCtrl.enable(); this.filteredList = this.allAccounts; }
    }));
    this.subscriptions.push(this.persistance.subscribe((data) => {
      this.selectedAccounts = data;
      this.submittedNumber = this.selectedAccounts.length;
      this.isAllSelected = (this.selectedAccounts.length &&
        (this.selectedAccounts.length === this.allAccounts.length));
      this.selectedAccountCopy = [...this.selectedAccounts];
      this.filteredList.forEach(element => {
        element.isSelected =
          (this.selectedAccounts.findIndex((y) => y.accountCode === element.accountCode)) > -1;
      });
    }));
    this.subscriptions.push(this.broadcastService.subscribe().subscribe(message => {
      if (message.type === 'SET_SELECTED_ACCOUNT') {
        this.selectedAccounts = message.payload;
        this.submittedNumber = this.selectedAccounts.length;
        this.filteredList.forEach(element => {
          element.isSelected =
            (this.selectedAccounts.findIndex((y) => y.accountCode === element.accountCode)) > -1;
        });
      }
    }));
  }

 ngAfterViewChecked(): void {
  const collection = document.getElementsByClassName('virtual-list1');
  const outerInput = collection[collection.length - 1];

  if (outerInput) {
    const inputBounds = outerInput.getBoundingClientRect();
    this.autoCompleteWidth = inputBounds;

    if (this.isSearching) {
      const footerHeight = 48;
      const minimumDropDownHeight = 100;
      const viewportPadding = 8;
      const preferredPanelHeight = 200 + footerHeight;
      const minimumPanelHeight = minimumDropDownHeight + footerHeight;
      const availableHeight = window.innerHeight - viewportPadding * 2;
      const panelHeight = Math.min(
        preferredPanelHeight,
        Math.max(minimumPanelHeight, availableHeight)
      );
      const spaceBelow =
        window.innerHeight - inputBounds.bottom - viewportPadding;

      this.autoCompleteTop =
        spaceBelow >= panelHeight
          ? inputBounds.bottom + 4
          : Math.max(
              viewportPadding,
              window.innerHeight - panelHeight - viewportPadding
            );

      this.autoCompleteHeight = panelHeight;
      this.dropDownHeight = panelHeight - footerHeight;
    }
  }

  this.cdr.detectChanges();
}

  selectedAll(isSelected) {
    this.isAllSelected = isSelected;
    this.filteredList.forEach(element => {
      element.isSelected = (isSelected) ? true : false;
    });
    if (isSelected) {
      this.selectedAccounts = this.allAccounts;
    } else { this.selectedAccounts = []; }
  }

  selectField(event, list) {
    if (!event.checked) { this.isAllSelected = false; }
    this.filteredList.map(element => {
      if (element.accountCode === list.accountCode) {
        element.isSelected = event.checked;
        this.removeSelectedAcc(list, event.checked);
      }
      return element;
    });
  }

  clearAll() {
    this.isAllSelected = false;
    this.filteredList = this.allAccounts.slice();
    this.filteredList.forEach(element => {
      element.isSelected = false;
    });
    this.selectedAccounts = [];
  }

  applyFilter() {
    this.selectedAccountCopy = [...this.selectedAccounts];
    this.submittedNumber = this.selectedAccounts.length;
    this.selectedValues.emit(this.selectedAccounts);
    this.dismissSearchBox();
  }

  setIsSearchingValue()
  {
    if(!this.isSearching) {
    this.isSearching = true;
    }
    else{
    this.isComboxBoxOpen = true;
    }
  }

  getRealSelectedValue() {
    if (this.blocking) {
      this.broadcastService.freezeScreenDropDownOpen();
    }
    if (this.selectedAccountCopy.length && !this.isComboxBoxOpen) {
      this.filteredList.forEach(element => {
        element.isSelected = (this.selectedAccountCopy
            .findIndex((x => x.accountCode === element.accountCode)) > -1 )
        ? true : false;
      });
      this.selectedAccounts = [...this.selectedAccountCopy];
    }
  }

  private removeSelectedAcc(list , isChecked) {
    const index = this.selectedAccounts.findIndex((u) => u.accountCode === list.accountCode);
    if (isChecked && index === -1) {
      const filterted = this.allAccounts.find((y) => y.accountCode === list.accountCode);
      this.selectedAccounts.push(filterted);
    } else {
      this.selectedAccounts = [
        ...this.selectedAccounts.slice(0, index),
        ...this.selectedAccounts.slice(index + 1, this.selectedAccounts.length),
      ];
    }
  }

  private _filter(value: string): any[] {
    const word = [value.toLowerCase().trim()];
    let acc: any[] = [];
    if (word) {
      word.forEach(x => {
        const val = this.allAccounts.filter(o =>
          Object.keys(o).some(k => (o.linkedAccountName + ' ' + o.accountCode).toLowerCase().includes(x)));
        val.forEach((y) => { y.isSelected = this.selectedAccounts.findIndex((n) => n.accountCode === y.accountCode) > -1; });
        acc = acc.concat(val).filter((v, i, a) => a.indexOf(v) === i);
      });
    }
    this.noData = acc.length > 0 ? false : true;
    return acc;
  }
  
  private dismissSearchBox() {
    const self = this;
    setTimeout(() => {
      self.ctrlInput.nativeElement.blur();
      self.accontListCtrl.setValue('');
      self.filteredList = this.allAccounts.slice();
      self.isSearching = false;
      self.isComboxBoxOpen = false;
      if (this.blocking) {
        this.broadcastService.unFreezeScreenDropDownClose();
      }
    }, 0);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
